import React, { useEffect, useRef } from 'react';
import './Objective.css'

const Objective = () => {
  const objectiveRef = useRef(null);
  const itemsRef = useRef([]);

  useEffect(() => {
    const listItems = document.querySelectorAll('.objective-list li');

    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;

      listItems.forEach((item) => {
        if (scrollPosition >= item.offsetTop + item.offsetHeight / 2) {
          item.classList.add('animate');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="objective-container" ref={objectiveRef} >
    <h2 className="objective-heading">OUR OBJECTIVES</h2>
    <ul className="objective-list">
      <li> To impart quality education that can transform the living standards of the people and help them to lead their lives as successful professionals and responsible citizens.</li>
      <li>To provide a conducive learning environment with essential facilities, ensuring that students can acquire knowledge in a practical and immersive manner.</li>

      <li>To provide contemporary teaching techniques and facilities for better learning</li>
      <li>To make education affordable for everyone so that every citizen can benefit from our institute.</li>
      <li>To deliver high-quality programs tailored for business organizations, focusing on staff training and management development.</li>
      <li>To develop professional ethics in the students so that they can cope up with challenges of practical life.</li>
      <li>Prepare students for national and international organizational requirements, fostering tomorrow's leaders with lateral thinking, critical analysis, and a mindset that embraces and respects cultural diversity.</li>
      <li>The institute aims to establish a dedicated 'Research & Development' Centre to foster and promote research and innovation activities.</li>
      {/* <li>To develop professional ethics in the students so that they can cope up with challenges of practical life.</li>
      <li>To make education affordable for everyone so that every citizen can benefit from our institute.</li>
      <li>To provide all modern era teaching techniques and facilities for better learning.</li>
      <li>To offer high quality programs to business organizations for staff training and management development to enhance corporate productivity and efficiency.</li>
      <li>To impart quality education that can transform the living standards of the people and help them to lead their lives as successful professionals and responsible citizens.</li>
      <li>To provide a congenial learning environment with important facilities to students so that they can acquire knowledge in the most pragmatic way.</li>
      <li>To establish ‘Job Placement Centre’ for professional grooming and training of the students and helping them to acquire better employment opportunities.</li> */}
      <li style={{backgroundColor: "red"}}>To produce leadership at the global level.</li>
    </ul>
    </div>
  );
};

export default Objective;

